<script>
import EggOrderItemEditPackedRow from '@/layer/components/EggOrderItemEditPackedRow.vue';

export default {
  components: {
    EggOrderItemEditPackedRow,
  },

  props: {
    heading: { type: String, required: true },
    items: { type: Array, required: true },
    boxesAndExtraFromItem: { type: Function, required: true },
    packedBoxesAndExtraFromItem: { type: Function, required: true },
    disabled: { type: Boolean, required: true },
  },

  computed: {
    itemsWithQuantities() {
      return this.items
        .filter(x => {
          let boxesAndExtra = this.boxesAndExtraFromItem(x);
          return boxesAndExtra.boxes > 0 || boxesAndExtra.extra > 0;
        });
    },
    hasNoItems() { return this.itemsWithQuantities.length === 0 },
  },
}
</script>

<template>
  <b-card>
    <h4 class="text-center"> {{heading}} </h4>

    <div v-for="item in itemsWithQuantities" :key="item.id" class="mb-4">
      <egg-order-item-edit-packed-row
        :item="item"
        :disabled="disabled"
        :boxes-and-extra-from-item="boxesAndExtraFromItem"
        :packed-boxes-and-extra-from-item="packedBoxesAndExtraFromItem" />
    </div>

    <div v-if="hasNoItems">
      No items
    </div>
  </b-card>
</template>



// WEBPACK FOOTER //
// src/layer/components/EggOrderItems.vue